module.exports = __webpack_public_path__ + "img/home1.bf896373.png";